import { render, staticRenderFns } from "./BaseQuestionPanel.vue?vue&type=template&id=a26313da&scoped=true&"
import script from "./BaseQuestionPanel.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26313da",
  null
  
)

export default component.exports